export function searchFilter(player, searchString){
    return player.name.toLowerCase().includes(searchString.toLowerCase());
}
export function positionFilter(player, pos_filter){
    return pos_filter === "all" || player.positions.includes(pos_filter);
}
export function getTeams(games) {
    let teams = [];
    //iterate through games and add teams
    for(let i = 0; i < games.length; i++) {
        let game = games[i];
        let home_team = game.home_team;
        let away_team = game.away_team;
        if(!teams.includes(home_team)) {
            teams.push(home_team);
        }
        if(!teams.includes(away_team)) {
            teams.push(away_team);
        }
    }
    //sort teams by property short_name
    teams.sort(function(a, b) {
        return a.short_name.localeCompare(b.short_name);
    });
    return teams;
}
export function filterByTeam(playerTeam, selectedTeam){
    if(playerTeam == selectedTeam || selectedTeam == "all") {
        return true;
    } else {
        return false;
    }
}
export function gameStrings(games) {
    let gameStrings = {};
    for(let i = 0; i < games.length; i++) {
        let game = games[i];
        gameStrings[game.away_team.short_name] = `<b>${game.away_team.short_name}</b> @ ${game.home_team.short_name}`;
        gameStrings[game.home_team.short_name] = `${game.away_team.short_name} @ <b>${game.home_team.short_name}</b>`;
    }
    return gameStrings;
}